"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zQty = exports.zMoney = void 0;
exports.formatMoney = formatMoney;
exports.formatQty = formatQty;
exports.parseMoneyInput = parseMoneyInput;
const zod_1 = require("zod");
const MONEY_RE = /^-?\d+\.\d{2}$/;
const QTY_RE = /^-?\d+(\.\d{1,3})?$/;
exports.zMoney = zod_1.z
    .string()
    .regex(MONEY_RE, "must be a 2-decimal-place amount, e.g. \"672.58\"")
    .transform((v) => v);
exports.zQty = zod_1.z
    .string()
    .regex(QTY_RE, "must be a decimal quantity with up to 3 places, e.g. \"1.000\"")
    .transform((v) => v);
/** Formats a Money string for display, e.g. "672.58" -> "$672.58". Pure string ops, no arithmetic. */
function formatMoney(m) {
    const negative = m.startsWith("-");
    const abs = negative ? m.slice(1) : m;
    const [whole = "0", cents = "00"] = abs.split(".");
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${negative ? "-" : ""}$${grouped}.${cents}`;
}
/** Formats a Qty string for display, trimming to the digits it actually
 * has — e.g. "1.000" -> "1", "1.100" -> "1.1", "1.550" -> "1.55",
 * "1.125" -> "1.125" unchanged. The DB column is a fixed numeric(10,3),
 * so a plain quantity always round-trips as "1.000" — printing that
 * verbatim reads as a precision the shop never actually recorded. Pure
 * string ops, no arithmetic. */
function formatQty(q) {
    if (!q.includes("."))
        return q;
    return q.replace(/0+$/, "").replace(/\.$/, "");
}
/** Validates and normalises a user-typed money string, or returns null. No arithmetic performed. */
function parseMoneyInput(raw) {
    const trimmed = raw.trim().replace(/^\$/, "").replace(/,/g, "");
    if (!/^-?\d+(\.\d{1,2})?$/.test(trimmed))
        return null;
    const [whole, cents = ""] = trimmed.split(".");
    const padded = `${whole}.${cents.padEnd(2, "0")}`;
    return MONEY_RE.test(padded) ? padded : null;
}
//# sourceMappingURL=money.js.map